var $38b2122ea1a115cf$exports = {};
$38b2122ea1a115cf$exports = {
    "maximum": `Maksim\u{101}l\u{101} v\u{113}rt\u{12B}ba`,
    "minimum": `Minim\u{101}l\u{101} v\u{113}rt\u{12B}ba`
};


export {$38b2122ea1a115cf$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
